export const ROOMMAP_FETCH = 'ROOMMAP_FETCH';
export const ROOMMAP_RECEIVE = 'ROOMMAP_RECEIVE';
export const ROOMMAP_ISLOADING = 'ROOMMAP_ISLOADING';
export const ROOMMAP_APIERROR = 'ROOMMAP_APIERROR';

export const USERREG_FETCHTOKENS = 'USERREG_FETCHTOKENS';
export const USERREG_RECEIVETOKENS = 'USERREG_RECEIVETOKENS';
export const USERREG_CHECKLICENSE = 'USERREG_CHECKLICENSE';
export const USERREG_LICENSECHECKED = 'USERREG_LICENSECHECKED';
export const USERREG_APIERROR = 'USERREG_APIERROR';

export const PERSON_SELECT = 'PERSON_SELECT';
export const PERSONMAP_FETCH = 'PERSONMAP_FETCH';
export const PERSONMAP_RECEIVE = 'PERSONMAP_RECEIVE';
export const PERSONMAP_ISLOADING = 'PERSONMAP_ISLOADING';
export const PERSONMAP_APIERROR = 'PERSONMAP_APIERROR';

export const ITEMTYPE_FETCH = 'ITEMTYPE_FETCH';
export const ITEMTYPE_RECEIVE = 'ITEMTYPE_RECEIVE';
export const ITEMLOCATION_FETCH = 'ITEMLOCATION_FETCH';
export const ITEMLOCATION_RECIEVE = 'ITEMLOCATION_RECIEVE';
export const ITEMRECIPIENTS_FETCH = 'ITEMRECIPIENTS_FETCH';
export const ITEM_TO_RECIPIENTS_RECIEVE = 'ITEM_TO_RECIPIENTS_RECIEVE';
export const ITEM_CC_RECIPIENTS_RECIEVE = 'ITEM_CC_RECIPIENTS_RECIEVE';
export const ITEM_BCC_RECIPIENTS_RECIEVE = 'ITEMRECIPIENTS_RECIEVE';
export const ITEM_SENDER_RECIEVE = 'ITEM_SENDER_RECIEVE';



